// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__EehLJ","options":"AnswerScale_options__2kWCb","selected":"AnswerScale_selected__2YfPX"};